<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card reporting-category-modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Reporting Tracker History
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="enable-select-text">
          <circul8-table
            ref="circul8Table"
            className="reporting-category-history-table"
            :records="data"
            :fields="columns"
            :routeNext="false"
            :usePropRecords="true"
            :showRemoveButton="false"
            :showEditButton="false"
            :showViewButton="false"
            :isCheckable="false"
            :maxTextLength="'36'"
            :allCountries="countries"
          />
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-normal" @click="cancel">
          Close
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import Circul8Table from "../../components/Circul8Table.vue";
export default {
  name: "ReportingTrackerHistoryModal",
  mixins: [utilityMixin, ScopeMixin],
  components: { Circul8Table },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    data: {}
  },
  data() {
    return {
      isModalActive: false,
      columns: [
        {
          field: "field",
          label: "Field",
          searchable: true
        },
        {
          field: "old_value",
          label: "Old Value",
          searchable: true
        },
        {
          field: "new_value",
          label: "New Value",
          searchable: true
        },
        {
          field: "user",
          label: "User",
          searchable: true
        },
        {
          field: "updated_at",
          label: "Updated at Date",
          searchable: true
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions"
        }
      ]
    };
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
